import * as yupImport from 'yup'
import './customYupValidators'

export type {
  AnyObject,
  ArraySchema,
  BooleanSchema,
  InferType,
  ObjectSchema,
  Schema,
  StringSchema,
  ValidationError,
} from 'yup'

const dateRange = () =>
  yupImport.object().shape({
    from: yupImport.date().required(),
    to: yupImport.date().required(),
  })

export const yup = { ...yupImport, dateRange }

export {
  type ArrayPath,
  type FieldValues,
  FormProvider,
  type Path,
  type PathValue,
  type UseControllerProps,
  type UseFormSetValue,
  type UseFormWatch,
  useFieldArray,
  useFormContext,
} from 'react-hook-form'
export * from './customYupValidators'
export * from './Form'
export * from './FormLocalizationProvider'
export * from './functions'
export * from './hooks'
export * from './Inputs'
export * from './typings'
export * from './wrappers'
